module.exports = __webpack_public_path__ + "static/media/ecommerce_n_websites_landingpage.be11edec.webp";